import React from 'react';
import styles from './ConfirmationPopup.module.scss';
import WarningIcon from 'images/warning-triangle-fill.svg';
import { Button, Popup } from '@missionlabs/smartagent-app-components';
interface Props {
    title: string;
    subtitle: string;
    leftButtonOnClick: () => void;
    leftButtonText: string;
    rightButtonOnClick: () => void;
    rightButtonText: string;
    warningText?: string;
}

const ConfirmationPopup: React.FC<Props> = ({
    title,
    subtitle,
    leftButtonOnClick,
    leftButtonText,
    rightButtonOnClick,
    rightButtonText,
    warningText,
}) => {
    return (
        <Popup center>
            <div className={styles.container}>
                <h3 className={styles.title}>{title}</h3>
                <div className={styles.subtitle}>{subtitle}</div>
                {warningText && (
                    <div className={styles.warning}>
                        <img src={WarningIcon} alt="Warning icon" />
                        {warningText}
                    </div>
                )}
                <div className={styles['button-container']}>
                    <Button
                        styling="simple"
                        className={styles.button}
                        onClick={leftButtonOnClick}
                    >
                        {leftButtonText}
                    </Button>
                    <Button
                        styling="red"
                        className={styles.button}
                        onClick={rightButtonOnClick}
                    >
                        {rightButtonText}
                    </Button>
                </div>
            </div>
        </Popup>
    );
};

export default ConfirmationPopup;
